import { render, staticRenderFns } from "./RequestedVerificationDocuments.vue?vue&type=template&id=92a7ccae&scoped=true&"
import script from "./RequestedVerificationDocuments.vue?vue&type=script&lang=js&"
export * from "./RequestedVerificationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./RequestedVerificationDocuments.vue?vue&type=style&index=0&id=92a7ccae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a7ccae",
  null
  
)

export default component.exports